<script lang="ts">
	import sectionImage3Xl from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&imagetools";
	import sectionImageXs from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&w=800&imagetools";
	import sectionImageSm from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&w=960&imagetools";
	import sectionImageLg from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&w=1600&imagetools";
	import sectionImageXl from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&w=1920&imagetools";
	import sectionImage2Xl from "@assets/images/pouring-coffee-from-a-pot.jpg?webp&w=2400&imagetools";
	import ImageSection from "./ImageSection.svelte";
</script>

<ImageSection
	class="!h-[calc(100vh-4rem)]"
	sources={{
		default: sectionImageXs,
		">lg": sectionImageLg,
		">sm": sectionImageSm,
		">xl": sectionImageXl,
		">2xl": sectionImage2Xl,
		">3xl": sectionImage3Xl,
	}}
	media="object-[40%_25%]"
	darkOverlay
/>
